var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1000002918(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 54,
    viewBox: "0 0 88 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9425 53.0537L30.2383 53.0556L30.3403 52.7778L38.3564 30.956L38.5643 30.3898H37.9612H33.5178H33.2239L33.1226 30.6656L25.1155 52.4593L24.9089 53.0217L25.5081 53.0255L29.9425 53.0537Z",
    fill: "#ED1C24",
    stroke: "#ED1C24",
    strokeWidth: 0.842054
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1893 53.055L39.4851 53.0569L39.5872 52.7792L50.1192 24.1108L50.3272 23.5445H49.724H45.2793H44.9855L44.8841 23.8204L34.3624 52.4606L34.1558 53.023L34.7549 53.0268L39.1893 53.055Z",
    fill: "#FFF200",
    stroke: "#FFF200",
    strokeWidth: 0.842054
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4361 53.0547L48.732 53.0566L48.834 52.7788L65.1956 8.23999L65.3408 7.84479L64.9456 7.69961L61.0293 6.26081L60.634 6.11561L60.4889 6.51083L43.6092 52.4603L43.4026 53.0226L44.0017 53.0265L48.4361 53.0547Z",
    fill: "#25B6AC",
    stroke: "#25B6AC",
    strokeWidth: 0.842054
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9999 53.0541H86.6024L86.3953 52.4883L70.6928 9.59988L70.2204 8.30947L69.8889 9.64306L68.091 16.8756L68.0599 17.0007L68.1042 17.1218L79.4204 48.0405H60.6439H60.3127L60.2347 48.3623L59.2229 52.5338L59.0967 53.0541H59.6321H85.9999Z",
    fill: "#4843BB",
    stroke: "#4843BB",
    strokeWidth: 0.842054
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0582 1.9097L64.9018 1.19742L64.3631 1.68902L57.9603 7.53272L57.4217 8.02428L58.1167 8.24498L66.3789 10.8687L67.074 11.0894L66.9176 10.3771L65.0582 1.9097Z",
    fill: "#25B6AC",
    stroke: "#25B6AC",
    strokeWidth: 0.842054
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8968 19.1214L22.0001 19.3925H22.2903H26.7336H27.3381L27.1286 18.8256L20.9053 1.98565L20.8036 1.71056H20.5104H9.15893H8.99856L8.87883 1.81725L0.673026 9.12925L0.532098 9.25483V9.44359V31.7912V45.4753V45.664L0.672999 45.7896L8.8788 53.1029L8.99854 53.2096H9.15893H20.5104H20.8036L20.9053 52.9345L27.1286 36.0946L27.3381 35.5276H26.7336H22.2903H22.0001L21.8968 35.7988L17.0194 48.6051H10.7542L5.13659 43.6002V31.7912V11.3187L10.7542 6.31505H17.0194L21.8968 19.1214Z",
    fill: "#4843BB",
    stroke: "#4843BB",
    strokeWidth: 0.842054
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002918);
export default __webpack_public_path__ + "static/media/Group 1000002918.a1725eaed87918aed326bd0de2caf87f.svg";
export { ForwardRef as ReactComponent };